import axios from 'axios';
import ResultCenter from '../entity/result-center.entity';

export default class ResultCenterService {
  public static getResultCentersByBusinessUnitId(businessUnitId: string): Promise<ResultCenter[]> {
    return axios.get(`/api/result-centers?businessUnitId=${businessUnitId}`)
      .then(({ data }) => data.map((it: any) => new ResultCenter(it)))
  }

  public static getAllActiveResultCenters(): Promise<ResultCenter[]> {
    return axios.get('/api/result-centers/active')
      .then(({ data }) => data.map((it: any) => new ResultCenter(it)))
  }
}
